var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"breadcrumb"},[_c('div',{staticClass:"container"},[_c('b-row',[_c('div',{staticClass:"breadcrumb__iner col-lg-12 text-center"},[_c('h2',[_vm._v(_vm._s(_vm.breadcrumbText))])])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }